import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createSubscription,
  cancelSubscription,
  changePlan,
  activateSubscription,
  type CreateSubscriptionRequestDto,
  type ActivateSubscriptionRequestDto,
} from "../infrastructure/subscription.api";

export function useSubscription() {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (dto: CreateSubscriptionRequestDto) => createSubscription(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
    },
  });

  const activateMutation = useMutation({
    mutationFn: (dto: ActivateSubscriptionRequestDto) => activateSubscription(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
    },
  });

  const cancelMutation = useMutation({
    mutationFn: ({ id, immediate }: { id: string; immediate?: boolean }) =>
      cancelSubscription(id, immediate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
    },
  });

  const changePlanMutation = useMutation({
    mutationFn: ({ id, newPlanId }: { id: string; newPlanId: string }) =>
      changePlan(id, newPlanId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
    },
  });

  return {
    create: createMutation.mutateAsync,
    activate: activateMutation.mutateAsync,
    cancel: cancelMutation.mutateAsync,
    changePlan: changePlanMutation.mutateAsync,
    isLoading:
      createMutation.isPending ||
      activateMutation.isPending ||
      cancelMutation.isPending ||
      changePlanMutation.isPending,
  };
}
